webpackJsonp([118442821920679],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Buyvariants(props) {
	
	  var v = props.on;
	  var obj1 = null;
	  var objo = null;
	
	  switch (v) {
	    case 'on0':
	
	      obj1 = props.post.on0;
	      objo = props.post.on0_options.split(',');
	      break;
	    case 'on1':
	      obj1 = props.post.on1;
	      objo = props.post.on1_options.split(',');
	      break;
	    case 'on2':
	      obj1 = props.post.on2;
	      objo = props.post.on2_options.split(',');
	      break;
	  }
	
	  if (props.post.option1 != '') {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement("input", { type: "hidden", name: v, value: obj1 }),
	      obj1,
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "select",
	        { name: props.sn },
	        objo.map(function (i) {
	          return _react2.default.createElement(
	            "option",
	            { value: i },
	            i
	          );
	        })
	      ),
	      _react2.default.createElement("br", null)
	    );
	  } else {
	    return '';
	  }
	}
	
	function Buyoptions(props) {
	
	  var v = props.on;
	  var obj1 = null;
	  var objo = null;
	
	  switch (v) {
	    case 'option1':
	
	      obj1 = props.post.option1;
	      objo = props.post.option1_options;
	      break;
	    case 'option2':
	
	      obj1 = props.post.option2;
	      objo = props.post.option2_options;
	      break;
	    case 'option3':
	
	      obj1 = props.post.option3;
	      objo = props.post.option3_options;
	      break;
	  }
	
	  if (props.post.option1 != '') {
	    return _react2.default.createElement(
	      "div",
	      null,
	      obj1,
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "select",
	        { name: props.sn },
	        objo.map(function (i) {
	          return _react2.default.createElement(
	            "option",
	            { value: i },
	            i
	          );
	        })
	      ),
	      _react2.default.createElement("br", null)
	    );
	  } else {
	    return '';
	  }
	}
	
	var Parent = function (_React$Component) {
	  _inherits(Parent, _React$Component);
	
	  function Parent() {
	    _classCallCheck(this, Parent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Parent.prototype.render = function render() {
	    var post = this.props.post;
	
	    if (this.props.post.sub_items.length > 0 && this.props.post.sub_items[0]['option1_value'] != '') {
	
	      return _react2.default.createElement(
	        "form",
	        { action: 'https://www.e-junkie.com/ecom/gb.php?c=cart&cl=' + post.ej_shop_id + '&i=' + post.number + '&ejc=2', method: "POST", target: "ej_ejc", acceptCharset: "UTF-8" },
	        _react2.default.createElement(Buyoptions, { post: post, on: "option1", sn: "o1" }),
	        _react2.default.createElement(Buyvariants, { post: post, on: "on0", sn: "os0", hv: "os0" }),
	        _react2.default.createElement(Buyvariants, { post: post, on: "on1", sn: "os1", hv: "os1" }),
	        _react2.default.createElement("input", { type: "hidden", name: "c", value: "cart" }),
	        _react2.default.createElement("input", { type: "hidden", name: "cl", value: post.ej_shop_id }),
	        _react2.default.createElement("input", { type: "hidden", name: "i", value: post.number }),
	        _react2.default.createElement("input", { type: "hidden", name: "ejc", value: "2" }),
	        _react2.default.createElement("input", { type: "image", src: "https://www.e-junkie.com/ej/ej_add_to_cart.gif", alt: "Add to Cart", className: "ec_ejc_thkbx" })
	      );
	    } else {
	      return _react2.default.createElement(
	        "a",
	        { href: 'https://www.e-junkie.com/ecom/gb.php?c=cart&amp;i=' + post.number + '&amp;cl=' + post.ej_shop_id + '&amp;ejc=2', target: "ej_ejc", className: "ec_ejc_thkbx" },
	        _react2.default.createElement("input", { type: "image", src: "https://www.e-junkie.com/ej/ej_add_to_cart.gif", alt: "Add to Cart", className: "ec_ejc_thkbx" })
	      );
	    }
	  };
	
	  return Parent;
	}(_react2.default.Component);
	
	exports.default = Parent;
	module.exports = exports["default"];

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Sublinks(props) {
	  var categories = props.cats;
	
	  return _react2.default.createElement(
	    "ul",
	    { className: "subnav" },
	    categories.map(function (current) {
	      return _react2.default.createElement(
	        "li",
	        { key: current.id },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: current.path },
	          ucwords(current.name)
	        )
	      );
	    })
	  );
	}
	
	var Dropdown = function Dropdown(_ref) {
	  var show = _ref.show,
	      catarr = _ref.catarr;
	  return _react2.default.createElement(
	    "ul",
	    { className: "category-dropdown menu-" + (show ? "visible" : "hidden") },
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/category/all" },
	        "View All"
	      )
	    ),
	    catarr.map(function (current) {
	
	      if (current.children.length == 0) {
	        return _react2.default.createElement(
	          "li",
	          { className: "ej-catlink", key: current.category.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: current.category.path },
	            ucwords(current.category.name)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "li",
	          { className: "ej-catlink", key: current.category.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: current.category.path },
	            ucwords(current.category.name)
	          ),
	          _react2.default.createElement(Sublinks, { cats: current.children })
	        );
	      }
	    })
	  );
	};
	
	function ucwords(str) {
	  str = str.toLowerCase();
	  return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
	    return s.toUpperCase();
	  });
	};
	
	var Parent = function (_React$Component) {
	  _inherits(Parent, _React$Component);
	
	  function Parent() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Parent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.toggleDropdown = function () {
	      return _this.setState(function (state) {
	        return {
	          dropdownVisible: !state.dropdownVisible
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // toggles the dropdown each time it is called
	
	
	  Parent.prototype.render = function render() {
	    var catarr = [];
	    var cats = this.props.categories.filter(function (categories) {
	      return categories.node.name.length > 0;
	    }).map(function (_ref2) {
	      var category = _ref2.node;
	
	      if (category.root != 'none') {
	        for (var i in catarr) {
	          if (catarr[i].id == category.root) {
	            catarr[i].children.push(category);
	          }
	        }
	      } else {
	        catarr.push({
	          id: category.id,
	          name: category.name,
	          category: category,
	          children: []
	        });
	      }
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { id: "category-box", onClick: this.toggleDropdown },
	      _react2.default.createElement(
	        "div",
	        { className: "current-cat" },
	        this.props.current
	      ),
	      _react2.default.createElement(Dropdown, { show: this.state.dropdownVisible, catarr: catarr })
	    );
	  };
	
	  return Parent;
	}(_react2.default.Component);
	
	exports.default = Parent;
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Buynow = __webpack_require__(73);
	
	var _Buynow2 = _interopRequireDefault(_Buynow);
	
	var _CategoryDropdown = __webpack_require__(74);
	
	var _CategoryDropdown2 = _interopRequireDefault(_CategoryDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Index(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var posts = data.allEJitem.edges;
	  var categories = data.allEJcategory.edges;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "page-wrapper" },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Category: ' + pathContext.category + ' - Falken\'s Party Supplies' }),
	    _react2.default.createElement(
	      "section",
	      { className: "blog-hero" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Category: ",
	          pathContext.category
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "home-products" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "filter-options" },
	          _react2.default.createElement(
	            "div",
	            { className: "searchbox" },
	            _react2.default.createElement(
	              "form",
	              { id: "searchbox", action: "", method: "GET" },
	              _react2.default.createElement("input", { type: "text", name: "search", id: "search", placeholder: "Search" }),
	              _react2.default.createElement("input", { type: "submit", value: "Search" })
	            )
	          ),
	          _react2.default.createElement(_CategoryDropdown2.default, { categories: categories, current: pathContext.category })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "ej-shop-index" },
	          posts.filter(function (post) {
	            return post.node.name.length > 0;
	          }).map(function (_ref2) {
	            var post = _ref2.node;
	
	            if (post.tags.indexOf(pathContext.category) > -1) {
	              return _react2.default.createElement(
	                "div",
	                { className: "ej-item", key: post.id },
	                _react2.default.createElement("img", { src: post.image, alt: post.name }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "product-blurb" },
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    post.name
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    post.description
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "$",
	                    post.price
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "item-tags" },
	                    post.tags
	                  ),
	                  _react2.default.createElement(_Buynow2.default, { post: post })
	                )
	              );
	            } else {
	              return '';
	            }
	          })
	        )
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-category-js-4961bb21d4777e20f4c4.js